import React, {Component} from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import {Card, CardBody, Row, Col, FormGroup, Input, Button} from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import 'moment-timezone';
import {MapContainer} from '../Pages/Share';

const ATTACH_BASE_URL = 'https://driver.ghtranspo.com/trip_attachments';

class AdminTripPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trip_id: null,
            date: moment().tz('America/Halifax').format('YYYY-MM-DD'),
            driver_id: '',
            truck_id: '',
            comments: '',
            internal_notes: '',
            fuel_amount: '',
            fuel_litres: '',
            def_amount: '',
            def_litres: '',
            total_distance: '',
            total_hours: '',
            status: 'draft',
            rows: [
                {container: '', chassis: '', location: '', arrive: '', depart: '', odometer: '', delay: ''}
            ],
            drivers: [],
            trucks: [],
            loading: true,
            attachments: [],
            // movement/map state
            history: [],
            travel_line: {
                type: 'Feature',
                properties: {stroke: '#f00'},
                geometry: {type: 'LineString', coordinates: []}
            },
            bounds: {x1: false, y1: false, x2: false, y2: false},
            pings_display: [],
            open_popup: false,
            zoom_to: false,
            highlight_point: {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [0, 0]
                        }
                    }
                ]
            },
            mapstyle: 'https://api.maptiler.com/maps/streets-v2/style.json?key=6P8HshICDGDXoVd9nuYs',
            movement_start: '',
            movement_end: '',
            movement_loading: false,
            movement_equipment_name: '',
            movement_photo: null
        };
        this.saveTimeout = null;
        this.movementTimeout = null;
    }

    loadMovement = (trip_id, truck_id) => {
        const id = trip_id || this.state.trip_id;
        const equip = truck_id || this.state.truck_id;
        if (!id || !equip) return;
        const self = this;
        this.setState({movement_loading: true});
        axios.get('/api/admin/trips/' + id + '/movement')
            .then(function (resp) {
                const data = resp.data || {};
                const history = data.history || [];
                const tripEntries = data.trip_entries || [];
                // Combine tracker history and trip sheet entries into a single
                // chronological stream so the Detailed Movement Log can show
                // the manual entries in-line on the timeline. Mark entries so
                // the table can highlight them.
                const combined = [];
                history.forEach((h) => {
                    if (!h || !h.timestamp) return;
                    combined.push({
                        ...h,
                        is_trip_entry: 0
                    });
                });
                tripEntries.forEach((te) => {
                    if (!te || !te.timestamp) return;
                    combined.push({
                        timestamp: te.timestamp,
                        desc: te.desc || '',
                        is_trip_entry: 1
                    });
                });
                combined.sort((a, b) => {
                    const ta = a.timestamp || 0;
                    const tb = b.timestamp || 0;
                    return ta - tb; // oldest to newest
                });
                const travel_line = data.travel_line || self.state.travel_line;
                const bounds = data.bounds || self.state.bounds;
                let pings_display = [];
                if (history.length > 0) {
                    // default to latest ping in window
                    pings_display = [history[0]];
                }
                self.setState({
                    history: combined,
                    travel_line: travel_line,
                    bounds: bounds,
                    pings_display: pings_display,
                    movement_start: data.start || '',
                    movement_end: data.end || '',
                    movement_equipment_name: data.equipment_name || '',
                    movement_photo: data.photo || null,
                    movement_loading: false
                });
            })
            .catch(function (error) {
                self.setState({movement_loading: false});
                if (error && error.response && error.response.status === 401) {
                    window.location = '/login';
                }
            });
    }

    loadAttachments = (trip_id) => {
        const self = this;
        if (!trip_id) return;
        axios.get('/api/admin/trips/' + trip_id + '/attachments')
            .then(function (resp) {
                self.setState({attachments: (resp.data && resp.data.attachments) || []});
            })
            .catch(function () {
            });
    }

    componentDidMount() {
        document.title = 'Trip Sheet | Greenhaven';
        this.loadLookups();
        const trip_id = this.props.match && this.props.match.params && this.props.match.params.trip_id;
        if (trip_id) {
            this.loadTrip(trip_id);
        } else {
            this.setState({loading: false});
        }
    }

    loadLookups = () => {
        const self = this;
        axios.get('/api/admin/drivers')
            .then(function (resp) {
                self.setState({drivers: (resp.data && resp.data.drivers) || []});
            })
            .catch(function () {
            });
        axios.get('/api/admin/trucks')
            .then(function (resp) {
                self.setState({trucks: (resp.data && resp.data.trucks) || []});
            })
            .catch(function () {
            });
    }

    handleAttachmentChange = (e) => {
        if (!this.state.trip_id || this.state.status === 'validated') return;
        const files = e.target.files;
        if (!files || files.length === 0) return;
        const self = this;

        Array.from(files).forEach((file) => {
            const formData = new FormData();
            formData.append('file', file);
            axios.post('/api/admin/trips/' + self.state.trip_id + '/attachments', formData, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(function (resp) {
                self.loadAttachments(self.state.trip_id);

                const data = resp && resp.data ? resp.data : {};
                const container_number = data.container_number;
                if (container_number) {
                    Swal({
                        title: 'Container number identified',
                        text: 'Container number "' + container_number + '" was identified.',
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: 'Apply to Trip',
                        cancelButtonText: 'Ignore'
                    }).then((result) => {
                        const confirmed = (result && (result.isConfirmed || result.value));
                        if (!confirmed) return;
                        self.applyContainerNumberToTrip(container_number);
                    });
                }
            }).catch(function (error) {
                if (error && error.response && error.response.status === 401) {
                    window.location = '/login';
                    return;
                }
                Swal('Error', 'Failed to upload attachment.', 'error');
            });
        });
        // reset input so same file can be selected again if needed
        e.target.value = '';
    }

    applyContainerNumberToTrip = (container_number) => {
        if (!container_number) return;
        if (this.state.status === 'validated') return;

        const rows = [...this.state.rows];
        if (!rows.length) return;

        let targetIndex = rows.findIndex((r) => !r.container || String(r.container).trim() === '');
        if (targetIndex === -1) {
            targetIndex = 0;
        }

        rows[targetIndex] = {
            ...rows[targetIndex],
            container: container_number
        };

        this.setState({rows}, this.scheduleSave);
    }

    deleteAttachment = (attachment_id) => {
        if (!this.state.trip_id || this.state.status === 'validated') return;
        const self = this;
        Swal({
            title: 'Delete attachment?',
            text: 'This cannot be undone.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            const confirmed = (result && (result.isConfirmed || result.value));
            if (!confirmed) return;
            axios.delete('/api/admin/trips/' + self.state.trip_id + '/attachments/' + attachment_id)
                .then(function () {
                    self.loadAttachments(self.state.trip_id);
                })
                .catch(function (error) {
                    if (error && error.response && error.response.status === 401) {
                        window.location = '/login';
                        return;
                    }
                    Swal('Error', 'Failed to delete attachment.', 'error');
                });
        });
    }

    loadTrip = (trip_id) => {
        const self = this;
        axios.get('/api/admin/trips/' + trip_id)
            .then(function (resp) {
                if (!resp.data || !resp.data.trip) {
                    return;
                }
                const trip = resp.data.trip;
                const rows = (resp.data.rows || []).map(function (r) {
                    return {
                        container: r.container || '',
                        chassis: r.chassis || '',
                        location: r.location || '',
                        arrive: r.arrive || '',
                        depart: r.depart || '',
                        odometer: r.odometer || '',
                        delay: r.delay || ''
                    };
                });
                self.setState({
                    trip_id: trip.trip_id,
                    date: trip.date || self.state.date,
                    driver_id: trip.driver_id ? String(trip.driver_id) : '',
                    truck_id: trip.truck_id ? String(trip.truck_id) : '',
                    comments: trip.comments || '',
                    internal_notes: trip.internal_notes || '',
                    fuel_amount: trip.fuel_amount || '',
                    fuel_litres: trip.fuel_litres || '',
                    def_amount: trip.def_amount || '',
                    def_litres: trip.def_litres || '',
                    total_distance: trip.total_distance || '',
                    total_hours: trip.total_hours || '',
                    status: trip.status || 'draft',
                    rows: rows.length ? rows : self.state.rows,
                    loading: false
                });
                self.loadAttachments(trip.trip_id);
                self.loadMovement(trip.trip_id, trip.truck_id);
            })
            .catch(function (error) {
                self.setState({loading: false});
                if (error && error.response && error.response.status === 401) {
                    window.location = '/login';
                    return;
                }
            });
    }

    setField = (name, value) => {
        if (this.state.status === 'validated') return;

        // Confirm before moving to validated status, since it locks the trip
        if (name === 'status' && value === 'validated' && this.state.status !== 'validated') {
            const self = this;
            Swal({
                title: 'Mark as validated?',
                text: 'Once a trip is validated, it can no longer be edited.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, validate',
                cancelButtonText: 'Cancel'
            }).then((result) => {
                const confirmed = (result && (result.isConfirmed || result.value));
                if (!confirmed) return;
                self.setState({status: 'validated'}, self.scheduleSave);
            });
            return;
        }

        this.setState({[name]: value}, () => {
            this.scheduleSave();
            // Reload reference movement when the truck or trip date changes,
            // since both affect the movement time window and equipment.
            if (name === 'truck_id' || name === 'date') {
                this.scheduleMovementReload();
            }
        });
    }

    computeTotalDistance(rows) {
        let total = 0;
        let prevOdo = null;
        for (let i = 0; i < rows.length; i++) {
            const odo = rows[i].odometer !== '' && rows[i].odometer !== null ? parseFloat(rows[i].odometer) : null;
            if (prevOdo !== null && odo !== null && odo > prevOdo) {
                total += (odo - prevOdo);
            }
            prevOdo = odo !== null ? odo : prevOdo;
        }
        if (!isFinite(total) || total <= 0) return '';
        return String(Math.round(total * 10) / 10);
    }

    // Total hours worked: continuous span from the earliest to the latest event
    // across all rows. Includes both on-duty (arrive->depart at a stop) and
    // driving time (gaps between rows). Handles overnight trips.
    computeTotalHours(rows) {
        const toMinutes = (t) => {
            const parts = String(t).split(':');
            const h = parseInt(parts[0], 10);
            const m = parseInt(parts[1], 10);
            if (isNaN(h) || isNaN(m)) return null;
            return h * 60 + m;
        };

        const events = [];
        let last = null;
        for (let i = 0; i < rows.length; i++) {
            const arrive = rows[i].arrive;
            const depart = rows[i].depart;
            if (!arrive && !depart) continue;

            const arriveMin = arrive ? toMinutes(arrive) : null;
            const departMin = depart ? toMinutes(depart) : null;
            if (arriveMin === null && departMin === null) continue;

            // Process the row's events in order: arrive, then depart.
            // If a time is earlier than the previous event, it has wrapped past midnight.
            if (arriveMin !== null) {
                let m = arriveMin;
                if (last !== null && m < last) m += 24 * 60;
                events.push(m);
                last = m;
            }
            if (departMin !== null) {
                let m = departMin;
                const prev = arriveMin !== null ? events[events.length - 1] : last;
                if (prev !== null && m < prev) m += 24 * 60;
                events.push(m);
                last = m;
            }
        }

        if (events.length < 2) return '';
        const totalMin = events[events.length - 1] - events[0];
        if (totalMin <= 0) return '';
        const hours = totalMin / 60;
        return String(Math.round(hours * 10) / 10);
    }

    setRowField = (index, name, value) => {
        if (this.state.status === 'validated') return;
        const rows = [...this.state.rows];
        rows[index] = {...rows[index], [name]: value};
        if (name === 'odometer') {
            const num = value !== '' ? parseFloat(value) : null;
            rows[index].odometer = (num !== null && !isNaN(num)) ? String(Math.round(num)) : '';
        }
        const total_distance = this.computeTotalDistance(rows);
        const total_hours = this.computeTotalHours(rows);
        this.setState({rows, total_distance, total_hours}, () => {
            this.scheduleSave();
            if (name === 'arrive' || name === 'depart') {
                this.scheduleMovementReload();
            }
        });
    }

    addRow = () => {
        if (this.state.status === 'validated') return;
        const existing = this.state.rows || [];
        const lastRow = existing.length > 0 ? existing[existing.length - 1] : {};
        const newRow = {
            container: lastRow.container || '',
            chassis: lastRow.chassis || '',
            location: '',
            arrive: '',
            depart: '',
            odometer: '',
            delay: ''
        };
        const rows = [...existing, newRow];
        const total_distance = this.computeTotalDistance(rows);
        const total_hours = this.computeTotalHours(rows);
        this.setState({rows, total_distance, total_hours}, this.scheduleSave);
    }

    removeRow = (index) => {
        if (this.state.status === 'validated') return;
        const rows = this.state.rows.filter((_, i) => i !== index);
        const total_distance = this.computeTotalDistance(rows);
        const total_hours = this.computeTotalHours(rows);
        this.setState({rows, total_distance, total_hours}, this.scheduleSave);
    }

    buildPayload() {
        return {
            date: this.state.date,
            driver_id: this.state.driver_id ? parseInt(this.state.driver_id, 10) : null,
            truck_id: this.state.truck_id ? parseInt(this.state.truck_id, 10) : null,
            comments: this.state.comments || '',
            internal_notes: this.state.internal_notes || '',
            fuel_amount: this.state.fuel_amount || null,
            fuel_litres: this.state.fuel_litres || null,
            def_amount: this.state.def_amount || null,
            def_litres: this.state.def_litres || null,
            total_distance: this.state.total_distance || null,
            total_hours: this.state.total_hours || null,
            status: this.state.status || 'draft',
            rows: this.state.rows.map((r, idx) => ({
                seq: idx + 1,
                container: r.container || '',
                chassis: r.chassis || '',
                location: r.location || '',
                arrive: r.arrive || '',
                depart: r.depart || '',
                odometer: r.odometer !== '' && r.odometer !== null ? parseInt(r.odometer, 10) : null,
                delay: r.delay || ''
            }))
        };
    }

    saveTrip = () => {
        const self = this;
        const payload = this.buildPayload();
        if (!payload.driver_id) {
            Swal('Missing driver', 'Please select a driver.', 'warning');
            return;
        }
        if (this.state.trip_id) {
            axios.put('/api/admin/trips/' + this.state.trip_id, payload)
                .catch(function (error) {
                    if (error && error.response && error.response.status === 401) {
                        window.location = '/login';
                        return;
                    }
                    Swal('Error', 'Failed to save trip.', 'error');
                });
        } else {
            axios.post('/api/admin/trips', payload)
                .then(function (resp) {
                    const trip_id = resp.data && resp.data.trip_id;
                    if (trip_id) {
                        self.setState({trip_id});
                        self.props.history.push('/trips/' + trip_id);
                    }
                    Swal('Saved', 'Trip has been created.', 'success');
                })
                .catch(function (error) {
                    if (error && error.response && error.response.status === 401) {
                        window.location = '/login';
                        return;
                    }
                    Swal('Error', 'Failed to create trip.', 'error');
                });
        }
    }

    scheduleSave = () => {
        if (this.state.status === 'validated') return;
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }
        this.saveTimeout = setTimeout(() => {
            this.saveTrip();
        }, 1000);
    }

    scheduleMovementReload = () => {
        if (!this.state.trip_id || !this.state.truck_id) return;
        if (this.movementTimeout) {
            clearTimeout(this.movementTimeout);
        }
        this.movementTimeout = setTimeout(() => {
            this.loadMovement();
        }, 1500);
    }

    deleteTrip = () => {
        if (!this.state.trip_id) return;
        const self = this;
        Swal({
            title: 'Delete trip?',
            text: 'This cannot be undone.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            const confirmed = (result && (result.isConfirmed || result.value));
            if (!confirmed) return;
            axios.delete('/api/admin/trips/' + self.state.trip_id)
                .then(function () {
                    Swal('Deleted', 'Trip has been deleted.', 'success');
                    self.props.history.push('/trips');
                })
                .catch(function (error) {
                    if (error && error.response && error.response.status === 401) {
                        window.location = '/login';
                        return;
                    }
                    Swal('Error', 'Failed to delete trip.', 'error');
                });
        });
    }

    render() {
        const isCreate = !this.state.trip_id;
        const isLocked = this.state.status === 'validated';

        return (
            <ContentWrapper>
                <div className="content-heading d-flex justify-content-between align-items-center">
                    <div>{isCreate ? 'Create Trip' : `Trip #${this.state.trip_id}`}</div>
                    <div>
                        {!isCreate && (
                            <Button color="danger" size="sm" className="mr-2" onClick={this.deleteTrip}>
                                Delete
                            </Button>
                        )}
                    </div>
                </div>
                <Card className={this.state.loading ? 'card card-default whirl traditional mx-0' : 'card card-default mx-0'}>
                    <CardBody>
                        <form className="form-horizontal">
                            <Row>
                                <Col sm="12" md="3">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Date</label>
                                        {isLocked ? (
                                            <div>{this.state.date}</div>
                                        ) : (
                                            <Input type="date" value={this.state.date}
                                                   onChange={(e) => this.setField('date', e.target.value)}/>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="3">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Driver</label>
                                        {isLocked ? (
                                            <div>
                                                {(this.state.drivers.find(d => String(d.driver_id) === String(this.state.driver_id)) || {}).first_name} {(this.state.drivers.find(d => String(d.driver_id) === String(this.state.driver_id)) || {}).last_name}
                                            </div>
                                        ) : (
                                            <Input type="select" value={this.state.driver_id}
                                                   onChange={(e) => this.setField('driver_id', e.target.value)}>
                                                <option value="">(select driver)</option>
                                                {this.state.drivers.map((d) => (
                                                    <option key={d.driver_id} value={d.driver_id}>
                                                        {d.first_name} {d.last_name}
                                                    </option>
                                                ))}
                                            </Input>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="3">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Truck</label>
                                        {isLocked ? (
                                            <div>{(this.state.trucks.find(t => String(t.equipment_id) === String(this.state.truck_id)) || {}).name || ''}</div>
                                        ) : (
                                            <Input type="select" value={this.state.truck_id}
                                                   onChange={(e) => this.setField('truck_id', e.target.value)}>
                                                <option value="">(select)</option>
                                                {this.state.trucks.map((t) => (
                                                    <option key={t.equipment_id} value={t.equipment_id}>{t.name}</option>
                                                ))}
                                            </Input>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="3">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Status</label>
                                        {isLocked ? (
                                            <div>{this.state.status}</div>
                                        ) : (
                                            <Input type="select" value={this.state.status}
                                                   onChange={(e) => this.setField('status', e.target.value)}>
                                                <option value="draft">Draft</option>
                                                <option value="complete">Complete</option>
                                                <option value="validated">Validated</option>
                                            </Input>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm="12" md="3">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Fuel $</label>
                                        {isLocked ? (
                                            <div>{this.state.fuel_amount}</div>
                                        ) : (
                                            <Input type="number" step="0.01" min="0" value={this.state.fuel_amount}
                                                   onChange={(e) => this.setField('fuel_amount', e.target.value)}/>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="3">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Fuel L</label>
                                        {isLocked ? (
                                            <div>{this.state.fuel_litres}</div>
                                        ) : (
                                            <Input type="number" step="0.01" min="0" value={this.state.fuel_litres}
                                                   onChange={(e) => this.setField('fuel_litres', e.target.value)}/>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="3">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Def $</label>
                                        {isLocked ? (
                                            <div>{this.state.def_amount}</div>
                                        ) : (
                                            <Input type="number" step="0.01" min="0" value={this.state.def_amount}
                                                   onChange={(e) => this.setField('def_amount', e.target.value)}/>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="3">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Def L</label>
                                        {isLocked ? (
                                            <div>{this.state.def_litres}</div>
                                        ) : (
                                            <Input type="number" step="0.01" min="0" value={this.state.def_litres}
                                                   onChange={(e) => this.setField('def_litres', e.target.value)}/>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm="12" md="6">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Comments</label>
                                        {isLocked ? (
                                            <div>{this.state.comments}</div>
                                        ) : (
                                            <Input type="textarea" value={this.state.comments}
                                                   onChange={(e) => this.setField('comments', e.target.value)}/>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="6">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Internal Notes</label>
                                        {isLocked ? (
                                            <div>{this.state.internal_notes}</div>
                                        ) : (
                                            <Input type="textarea" value={this.state.internal_notes}
                                                   onChange={(e) => this.setField('internal_notes', e.target.value)}/>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <div className="table-responsive">
                                <table className="table table-sm">
                                    <thead className="thead-light" style={{fontSize: '0.8rem'}}>
                                    <tr>
                                        <th>Location</th>
                                        <th>Arr</th>
                                        <th>Dep</th>
                                        <th>Odo</th>
                                        <th>Cont #</th>
                                        <th>Chas #</th>
                                        <th>Delay</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.rows.map((row, idx) => (
                                        <tr key={idx}>
                                            <td style={{minWidth: 130}}>
                                                {isLocked ? (
                                                    <span>{row.location}</span>
                                                ) : (
                                                    <Input type="text" value={row.location}
                                                           onChange={(e) => this.setRowField(idx, 'location', e.target.value)}
                                                           placeholder="Location"/>
                                                )}
                                            </td>
                                            <td style={{minWidth: 80}}>
                                                {isLocked ? (
                                                    <span>{row.arrive}</span>
                                                ) : (
                                                    <Input type="time" step="60" bsSize="sm"
                                                           style={{fontSize: '0.8rem', paddingLeft: 4, paddingRight: 4, width: '100%'}}
                                                           value={row.arrive}
                                                           onChange={(e) => this.setRowField(idx, 'arrive', e.target.value)}/>
                                                )}
                                            </td>
                                            <td style={{minWidth: 80}}>
                                                {isLocked ? (
                                                    <span>{row.depart}</span>
                                                ) : (
                                                    <Input type="time" step="60" bsSize="sm"
                                                           style={{fontSize: '0.8rem', paddingLeft: 4, paddingRight: 4, width: '100%'}}
                                                           value={row.depart}
                                                           onChange={(e) => this.setRowField(idx, 'depart', e.target.value)}/>
                                                )}
                                            </td>
                                            <td style={{minWidth: 100}}>
                                                {isLocked ? (
                                                    <span>{row.odometer}</span>
                                                ) : (
                                                    <Input type="number" value={row.odometer}
                                                           onChange={(e) => this.setRowField(idx, 'odometer', e.target.value)}
                                                           placeholder="km"/>
                                                )}
                                            </td>
                                            <td style={{minWidth: 110}}>
                                                {isLocked ? (
                                                    <span>{row.container}</span>
                                                ) : (
                                                    <Input type="text" value={row.container}
                                                           onChange={(e) => this.setRowField(idx, 'container', e.target.value)}
                                                           placeholder="Cont #"/>
                                                )}
                                            </td>
                                            <td style={{minWidth: 100}}>
                                                {isLocked ? (
                                                    <span>{row.chassis}</span>
                                                ) : (
                                                    <Input type="text" value={row.chassis}
                                                           onChange={(e) => this.setRowField(idx, 'chassis', e.target.value)}
                                                           placeholder="Chas #"/>
                                                )}
                                            </td>
                                            <td style={{minWidth: 70}}>
                                                {isLocked ? (
                                                    <span>{row.delay}</span>
                                                ) : (
                                                    <Input type="number" min="0" value={row.delay}
                                                           onChange={(e) => this.setRowField(idx, 'delay', e.target.value)}
                                                           placeholder="Min."/>
                                                )}
                                            </td>
                                            <td className="text-right" style={{minWidth: 60}}>
                                                {!isLocked && (
                                                    <Button color="danger" size="xs" onClick={() => this.removeRow(idx)}>
                                                        <i className="fa fa-trash"/>
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                            {!isLocked && (
                                <div className="d-flex justify-content-center">
                                    <Button color="info" size="sm" onClick={this.addRow}>+ Add Row</Button>
                                </div>
                            )}

                            {/* Attachments */}
                            <Row className="mt-3">
                                <Col sm="12">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Attachments</label>
                                        {!isLocked && this.state.trip_id && (
                                            <div className="mb-2">
                                                <input
                                                    type="file"
                                                    accept="application/pdf,image/jpeg,image/jpg"
                                                    multiple
                                                    onChange={this.handleAttachmentChange}
                                                />
                                            </div>
                                        )}
                                        {this.state.attachments && this.state.attachments.length > 0 && (
                                            <ul className="list-unstyled mb-0">
                                                {this.state.attachments.map((a) => (
                                                    <li key={a.attachment_id}
                                                        className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                                        <a href={`${ATTACH_BASE_URL}/${a.file_name}`} target="_blank"
                                                           rel="noopener noreferrer">
                                                            {a.original_name || a.file_name}
                                                        </a>
                                                        {!isLocked && (
                                                            <Button color="danger" size="sm"
                                                                    onClick={() => this.deleteAttachment(a.attachment_id)}>
                                                                <i className="fa fa-trash"/>
                                                            </Button>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                        {(!this.state.attachments || this.state.attachments.length === 0) && (
                                            <div className="text-muted">No attachments yet.</div>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row className="mt-2">
                                <Col sm="12" md="6">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Distance Travelled (km)</label>
                                        {isLocked ? (
                                            <div>{this.state.total_distance}</div>
                                        ) : (
                                            <Input type="number" step="0.1" min="0" value={this.state.total_distance}
                                                   onChange={(e) => this.setField('total_distance', e.target.value)}/>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="6">
                                    <FormGroup className="bg-light">
                                        <label className="mb-0 font-weight-bold">Total Hours Worked</label>
                                        {isLocked ? (
                                            <div>{this.state.total_hours}</div>
                                        ) : (
                                            <Input type="number" step="0.1" min="0" value={this.state.total_hours}
                                                   onChange={(e) => this.setField('total_hours', e.target.value)}/>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col sm="12">
                                    <h4 className="mb-0">Detailed Movement Log</h4>
                                    <table className='table table-sm small table-hover mb-0 mt-2'>
                                        <thead className="thead-light">
                                        <tr>
                                            <th className="p-1">Date / Time</th>
                                            <th className="p-1">Location</th>
                                            <th className="p-1">Ignition</th>
                                            <th className="p-1 text-right">Speed</th>
                                            <th className="p-1">Dir.</th>
                                            <th className="p-1 text-right">Dist. Travelled</th>
                                            <th className="p-1 text-right">Odometer</th>
                                            <th className="p-1">Driver</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.history.map(function (ping, ping_num) {
                                            let rotate = false;
                                            if (ping.dir === 'n') {
                                                rotate = 315;
                                            } else if (ping.dir === 'ne') {
                                                rotate = 0;
                                            } else if (ping.dir === 'e') {
                                                rotate = 45;
                                            } else if (ping.dir === 'se') {
                                                rotate = 95;
                                            } else if (ping.dir === 's') {
                                                rotate = 135;
                                            } else if (ping.dir === 'sw') {
                                                rotate = 180;
                                            } else if (ping.dir === 'w') {
                                                rotate = 225;
                                            } else if (ping.dir === 'nw') {
                                                rotate = 270;
                                            }
                                            const rowClass = ping.is_trip_entry === 1 ? 'table-danger' : '';
                                            return (
                                                <tr key={ping_num} className={rowClass}>
                                                    <td className="p-0">{moment.unix(ping.timestamp).format('YYYY-MM-DD HH:mm')}</td>
                                                    <td className="p-0">{(ping.is_trip_entry === 1 ? '"' : '')}{ping.desc}{(ping.is_trip_entry === 1 ? '"' : '')}</td>
                                                    <td className={(ping.is_ignit === 1 ? 'p-0 text-success' : (ping.is_ignit === 2 ? 'p-0 text-dark' : ''))}>
                                                        {ping.is_ignit === 1 ? 'On' : (ping.is_ignit === 2 ? 'Off' : '')}
                                                    </td>
                                                    <td className="p-0 text-right">{ping.speed} {(ping.is_trip_entry === 1 ? '' : 'km/hr')}</td>
                                                    <td className="p-0" title={ping.dir}>
                                                        <i className={(rotate === false ? 'd-none' : 'fas fa-location-arrow')} style={{transform: 'rotate(' + rotate + 'deg)'}}/>
                                                    </td>
                                                    <td className="p-0 pr-1 text-right">{(ping.dist == null ? '' : ping.dist)} {(ping.is_trip_entry === 1 ? '' : 'km')}</td>
                                                    <td className="p-0 pr-1 text-right">{(ping.odometer == null ? '' : ping.odometer)}</td>
                                                    <td className="p-0 pl-1">{ping.driver}</td>
                                                </tr>
                                            );
                                        }, this)}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col sm="12">
                                    <h4 className="mb-0">Reference Map</h4>
                                    <div className="small text-muted mb-0">
                                        {this.state.movement_start && this.state.movement_end && (
                                            <>Showing activity from {this.state.movement_start} to {this.state.movement_end}</>
                                        )}
                                    </div>
                                    <div className={this.state.movement_loading ? 'card card-default whirl traditional' : 'card card-default'}>
                                        <div className="card-body p-0" style={{height: '350px'}}>
                                            <MapContainer
                                                travel_line={this.state.travel_line}
                                                planned_line={{type: 'Feature', properties: {stroke: '#2688FF'}, geometry: {type: 'LineString', coordinates: []}}}
                                                bounds={this.state.bounds}
                                                mapstyle={this.state.mapstyle}
                                                timestamp={0}
                                                pings_display={this.state.pings_display}
                                                open_popup={this.state.open_popup}
                                                zoom_to={this.state.zoom_to}
                                                highlight_point={this.state.highlight_point}
                                                photo={this.state.movement_photo}
                                                equipment_name={this.state.movement_equipment_name}
                                                startend={[]}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                        </form>
                    </CardBody>
                </Card>
            </ContentWrapper>
        );
    }
}

export default AdminTripPage;
